/////////////////////////////////////////////////////////////////////////////777
import { StickerCollection } from '@/core/interfaces';
import { CollectionItem } from '@/app/shared/components';

interface CollectionGridProps {
	collections: StickerCollection[];
}

export const CollectionGrid: React.FC<CollectionGridProps> = ({
	collections,
}) => {
	/*********************
	// #region Template
	**********************/
	return (
		<div className={`grid grid-cols-2 gap-4 max-w-xl mx-auto pt-8 pb-32`}>
			{collections &&
				collections.map((collection: StickerCollection) => {
					return (
						<CollectionItem
							key={collection.id}
							collection={collection}
						/>
					);
				})}
		</div>
	);
};
